/**
 * Button - Reusable button component with primary/secondary variants
 */
import Link from 'next/link';
import { twMerge } from 'tailwind-merge';

interface ButtonProps {
  title: string;
  icon?: React.ReactNode;
  url?: string | undefined;
  type?: 'primary' | 'secondary';
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function Button({ title, icon, url, type = 'primary', className, onClick }: ButtonProps) {
  const buttonClasses = twMerge(
    'btn flex h-[40px] flex-row items-center justify-center gap-2 px-3 py-4 transition-colors cursor-pointer',
    className,
    type === 'primary'
      ? 'btn-primary'
      : 'btn-secondary'
      
  );

  const buttonElement = (
    <button className={buttonClasses} onClick={onClick}>
      <span className="text-[14px] leading-[140%] font-medium text-[inherit]">{title}</span>
      {icon && icon}
    </button>
  );

  // Wrap in Link if URL provided without onClick handler
  if (url && !onClick) {
    return <Link href={url}>{buttonElement}</Link>;
  }

  return buttonElement;
}
